import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

// Stats without "年行業經驗"
const statKeys = [
  { value: '200+', key: 'stat_clients' },
  { value: '99.9%', key: 'stat_uptime' },
  { value: '24/7', key: 'stat_support' },
];

export default function Hero() {
  const [count, setCount] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setInterval(() => setCount(c => (c + 1) % 3), 3000);
    return () => clearInterval(timer);
  }, []);

  const highlightKeys = ['hero_highlight1', 'hero_highlight2', 'hero_highlight3'];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-950">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6f028b03e075820a7746e54b8976d9d8.jpg"
          alt="hero"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/60 via-slate-950/50 to-slate-950/80"></div>
        <div className="absolute inset-0 opacity-10" style={{backgroundImage: 'linear-gradient(rgba(0,201,167,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,201,167,0.3) 1px, transparent 1px)', backgroundSize: '60px 60px'}}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 pb-24 text-center">
        <AnimatedSection animation="fade-in" delay={0.1}>
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-8">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
            <span className="text-cyan-400 text-sm font-medium tracking-wider">{t('hero_badge')}</span>
          </div>
        </AnimatedSection>

        <AnimatedSection animation="fade-in" delay={0.2}>
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-4">
            <span className="text-cyan-400">{t('hero_title1')}</span>
            <br />
            {t('hero_title2')}
          </h1>
        </AnimatedSection>

        <AnimatedSection animation="fade-in" delay={0.3}>
          <div className="h-10 mb-6 flex items-center justify-center">
            <span className="text-slate-300 text-xl">
              {t('hero_focus')}&nbsp;
              <span className="text-cyan-400 font-semibold">{t(highlightKeys[count])}</span>
            </span>
          </div>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto leading-relaxed mb-10">
            {t('hero_desc')}
          </p>
        </AnimatedSection>

        <AnimatedSection animation="fade-in" delay={0.4}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-20">
            <Link
              to="/contact"
              className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-bold px-8 py-4 rounded-lg text-base transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta1')}
            </Link>
            <Link
              to="/case-studies"
              className="border border-slate-600 hover:border-cyan-500 text-white hover:text-cyan-400 px-8 py-4 rounded-lg text-base font-medium transition-all whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta2')}
            </Link>
          </div>
        </AnimatedSection>

        {/* Stats — 3 items only (年行業經驗 removed) */}
        <AnimatedSection animation="fade-in" delay={0.5}>
          <div className="grid grid-cols-3 gap-6 max-w-2xl mx-auto">
            {statKeys.map((stat) => (
              <div key={stat.key} className="bg-white/5 border border-white/10 rounded-xl p-5 backdrop-blur-sm">
                <div className="text-3xl font-bold text-cyan-400 mb-1">{stat.value}</div>
                <div className="text-slate-400 text-sm">{t(stat.key)}</div>
              </div>
            ))}
          </div>
        </AnimatedSection>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
          <div className="w-6 h-10 border border-slate-600 rounded-full flex items-start justify-center p-1.5">
            <div className="w-1 h-3 bg-cyan-400 rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
